"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/molecules/Accordion";
// [RUDDERSTACK-OLD disabled 2026-07-20] widget_viewed → now central widget_impression
// (TrackedWidget in NewPage); see webapp/docs/analytics
// import { FireWidgetViewedEvent } from "@/customAnalytics/trackingEvents";
import { cn } from "@/lib/utils";
import { useMemo, useRef } from "react";

interface MetaItem {
  id: string;
  meta_title: string;
  meta_title_text_color?: string;
  meta_description: string;
  meta_status: boolean;
  meta_priority: number;
}

interface ExaminationGuidelinesData {
  id?: number;
  page_id?: number;
  component_id?: number;
  background_color?: string;
  metadata?: MetaItem[];
  variant?: string;
  status?: number;
  is_deleted?: number;
}

interface ExaminationGuidelinesProps {
  data: {
    data: ExaminationGuidelinesData;
  };
}

const ExaminationGuidelines1 = ({ data }: ExaminationGuidelinesProps) => {
  const ref = useRef<HTMLElement>(null);

  const {
    background_color = "#FFFFFF",
    metadata = [],
    status = 1,
  } = data?.data || {};

  // Sort and filter metadata by priority and status
  const sortedMetadata = useMemo(() => {
    if (!metadata || metadata.length === 0) return [];
    return [...metadata]
      .filter((item) => item.meta_status)
      .sort((a, b) => a.meta_priority - b.meta_priority);
  }, [metadata]);

  // Track widget viewed
  // [RUDDERSTACK-OLD disabled 2026-07-20] impression now central; see webapp/docs/analytics
  // useEffect(() => {
  //   if (ref.current) {
  //     FireWidgetViewedEvent(ref, "examination_guidelines_section");
  //   }
  // }, []);

  // Don't render if no data or status is disabled
  if (!data?.data || status === 0) {
    return null;
  }

  return (
    <section
      ref={ref}
      className={cn("w-full px-5 py-8", "sm:px-9 sm:py-10")}
      style={{ backgroundColor: background_color }}
    >
      <div
        className={cn(
          "flex flex-col gap-4 w-full max-w-full",
          "sm:gap-6",
          "sm:max-w-[1080px] md:max-w-[1230px] lg:max-w-[1430px] xl:max-w-[1750px]",
          "mx-auto"
        )}
      >
        <Accordion
          type="single"
          collapsible
          defaultValue={sortedMetadata[0]?.id}
          className={cn("!z-1 border-[0.8px] border-gray-2 rounded-lg w-full")}
          style={{ backgroundColor: background_color }}
        >
          {sortedMetadata.map((item) => (
            <AccordionItem
              key={item.id}
              value={item.id}
              className={cn("border-gray-3 border-b-[1.6px]", "xs:py-4")}
            >
              <AccordionTrigger
                iconClassName="mr-0"
                className={cn(
                  "!text-heading-9-semibold !font-semibold cursor-pointer"
                )}
              >
                <div
                  className={cn(
                    "text-left",
                    "text-heading-6-semibold",
                    "sm:text-heading-5-semibold",
                    "md:text-heading-4-semibold",
                    "lg:text-new-heading-34-semibold",
                    "xl:text-new-heading-42-semibold"
                  )}
                  style={{ color: item.meta_title_text_color || "#000000" }}
                >
                  {item.meta_title}
                </div>
              </AccordionTrigger>
              <AccordionContent
                className={cn(
                  "flex flex-col gap-[18px]",
                  "xs:pt-[27px]",
                  "md:pt-6"
                )}
              >
                <div
                  className={cn(
                    "pr-4 pb-4",
                    "sm:pr-6 sm:pb-6",
                    "prose prose-sm max-w-none"
                  )}
                  dangerouslySetInnerHTML={{ __html: item.meta_description }}
                />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default ExaminationGuidelines1;
